module.exports = __webpack_public_path__ + "static/media/AboutScreen.a11539bf.png";